<template>
  <div>
    <v-img
      :src="require('@/assets/explore/menu/school.png')"
      max-width="70"
      @click="go()"
      class="menu-item d-flex justify-start align-end text-center"
    >
      <v-card v-if="auth && auth.schoolYear" class="text-caption">{{
        $_parseSchoolYear(auth.schoolYear)
      }}</v-card>
    </v-img>
  </div>
</template>
      
  <script>
import { mapState } from "vuex";
export default {
  components: {
    //
  },
  computed: mapState({
    auth: (state) => state.auth.data,
  }),
  props: [
    //
  ],
  data: () => ({
    //
  }),
  created() {
    //
  },
  async mounted() {
    //
  },
  methods: {
    go() {
      this.$router.push({
        name: "PageExploreClassmates",
      });
    },
  },
};
</script>

<style scoped>
.shake {
  -webkit-animation: shake 2s infinite ease-in-out;
  -moz-animation: shake 2s infinite ease-in-out;
  -ms-animation: shake 2s infinite ease-in-out;
  -o-animation: shake 2s infinite ease-in-out;
  animation: shake 2s infinite ease-in-out;
}
@keyframes shake {
  0% {
    transform: rotate(0) scale(1) skew(1deg);
  }
  10% {
    transform: rotate(-10deg) scale(1) skew(1deg);
  }
  20% {
    transform: rotate(10deg) scale(1) skew(1deg);
  }
  30% {
    transform: rotate(-10deg) scale(1) skew(1deg);
  }
  40% {
    transform: rotate(10deg) scale(1) skew(1deg);
  }
  50% {
    transform: rotate(0) scale(1) skew(1deg);
  }
  100% {
    transform: rotate(0) scale(1) skew(1deg);
  }
}

.menu-item {
  cursor: pointer;
}

.menu-item:hover {
  scale: 1.1;
}
</style>